import axios from 'axios'
import store from './store'
import config from './config'
import { logoutUser } from './util/authhelper.js'
// create a new axios instance
const instance = axios.create({
  baseURL: config.serverURI,
  withCredentials: true
})

instance.interceptors.request.use(function (config) {
  // read the persisted token (may be stored as 'Bearer <raw>' or just '<raw>')
  const stored = window.localStorage.getItem('token') || ''

  console.log('Interceptor - adding auth token if present')
  // endpoints that should not include the auth token in header
  const tokenUrls = ['generate-token', 'tokenlogout', 'logout', 'otp-validate', 'validate-otp']
  let tokenUrlFound = -1
  for (let i = 0; i < tokenUrls.length; i++) {
    tokenUrlFound = config.url.indexOf(tokenUrls[i])
    if (tokenUrlFound !== -1) break
  }
  // if we have a stored token and the current request is not one of the token endpoints,
  // set the Authorization header. Avoid double-prefixing 'Bearer ' if it's already present.
  if (stored && tokenUrlFound === -1) {
    const header = stored.startsWith('Bearer ') ? stored : `Bearer ${stored}`
    config.headers = config.headers || {}
    config.headers.Authorization = header
  }
  return config
}, function (err) {
  return Promise.reject(err)
})

// before a response is returned stop nprogress
instance.interceptors.response.use(response => {
  // console.log(response)
  return response
}, function (error) {
  // Do something with response error
  if (error.message.includes('Network Error')) {
    store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: 'Failed to connect to server, check network connectivity' }, { root: true })
  }
  if (error.response && error.response.status === 401) {
    // Check current route - don't logout if user is on auth pages
    const currentRoute = window.location.pathname
    const isOnAuthPage = currentRoute.includes('/login') || 
                        currentRoute.includes('otp') ||
                        currentRoute.includes('reset') ||
                        currentRoute.includes('tokenvalidate') ||
                        currentRoute.includes('password')
    
    // Skip logout completely while on authentication pages
    if (isOnAuthPage) {
      return Promise.reject(error)
    }
    
    // For other pages, only logout if endpoint is NOT authentication-related
    const url = error.response.config.url || ''
    const isAuthEndpoint = url.includes('generate-token') || 
                          url.includes('token/validate') ||
                          url.includes('validate-otp') || 
                          url.includes('refresh-token') ||
                          url.includes('tokenlogout') ||
                          url.includes('/logout')
    
    if (!isAuthEndpoint) {
      logoutUser(store.state.token)
    }
  }
  return Promise.reject(error)
})

export default instance
